import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { ConstantService } from 'app/Shared/Services/constant-service';
import { SharedHttpClientService } from 'app/Shared/Services/shared-http-client.service';
import { UrlsService } from 'app/Shared/Services/urls.service';
import { TableModule } from 'primeng/table';
import { default as compReviewSetupcols } from 'app/Pages/administration/cognito/comparative-review-setup/comparative-review-setup.json';
import { GridService } from 'app/Shared/Services/grid.service';
import { APIURL } from 'app/Shared/Constant/API_Urls';
import { UserService } from 'app/Shared/Services/user.service';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService, MessageService } from 'primeng/api';
import { map, Subscription } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';


@Component({
  selector: 'app-comparative-review-setup',
  templateUrl: './comparative-review-setup.component.html',
  styleUrl: './comparative-review-setup.component.scss',
  imports: [TableModule,MatProgressSpinnerModule,CommonModule,ConfirmDialogModule]

})
export class ComparativeReviewSetupComponent implements OnInit, OnDestroy {
  Dataset: any = [];
  gridColumns: any;
  isLoadingResults = false;
  totalRecords: any;
  GridColumns = compReviewSetupcols;
  public subscription!: Subscription;
  constructor(
    public constantService: ConstantService,
    private gridService: GridService,
    private sharedHttpClientService:SharedHttpClientService,
    private urlsService:UrlsService,
    private UserService:UserService,
    public confirmationService: ConfirmationService,
    private messageService: MessageService,
    
  ) { }

  ngOnInit() {
    this.getColumns();
    this.getData();
  }

  getColumns() {
    let column: any;
    column = this.GridColumns;
    if (column !== null || column !== undefined) {
      this.gridColumns = this.gridService.getGridColumns(column);
    }
  }
  getData(){
    this.isLoadingResults =true;
      this.sharedHttpClientService.get(
      this.urlsService.setAPIURl1(
        APIURL.GETCompReviewsetupDetails,
        this.UserService.getActiveMPID()
            )
          )
       .subscribe({
        next: (data:any) => {
         this.isLoadingResults =false;
            let dataDetails = data;
            if(dataDetails.Data) {
              this.Dataset = dataDetails.Data;
            }
        },
        error: (e) => {
          this.isLoadingResults =false;
        }
      });
  }

  isActiveChange(fieldValue:any,rowData:any){
    let message='';
    if(fieldValue === true){
      message  ='Do You Want to DeActivate  ' + rowData["Exception_CD"] + ' Exception for <b>ALL FIRMs</b>?';
    }
    else{
       message  ='Do You Want to make ' + rowData["Exception_CD"] + ' Exception Active for <b>ALL FIRMs</b>?';
    }
    this.confirmationService.confirm({
        message: message,
        key: 'submitInformationDialoge',
        acceptLabel: 'Yes',
        acceptIcon:'pi pi-check',
        rejectLabel: 'No',
        rejectIcon:'pi pi-times',
        acceptButtonStyleClass:"information-dialog-button",
        rejectButtonStyleClass:"information-dialog-button information-reject-button",

      accept: () => {
        this.UserService.logUserActivity((fieldValue ? "Deactivate" +" "+ rowData["Exception_CD"] +" "+ "exception for ALL FIRMs" : "Activate" +" "+ rowData["Exception_CD"] +" "+ "exception for ALL FIRMs"), null, {
        'Text1':this.UserService.userFirstName +" "+ (fieldValue ? "Deactivate" +" "+ rowData["Exception_CD"] +" "+ "exception for ALL FIRMs" : "Activate" +" "+ rowData["Exception_CD"] +" "+ " exception for ALL FIRMs"),
        'Text2': 'Comparative review setup details: ' + JSON.stringify(rowData)
        });
        this.isLoadingResults =true;
        let data = {
          "level": "complex",
          "IsActive": !fieldValue,
          "Exception_CD": rowData["Exception_CD"],
          "LastUpdated_By": this.UserService.getUserFirstName(),
        };
        this.sharedHttpClientService.post(this.urlsService.setAPIURl(APIURL.UpdateCompReviewsetupDetails), data)
          .pipe(map((response: Response) => {
            return response;
          }))
          .subscribe({
            next: (dataset: any) => {
              this.getData();
               this.messageService.add({ severity: 'success', summary: 'Updated', detail: 'Record Updated' });
            },
            error: (err: HttpErrorResponse) => {
              this.isLoadingResults = false;
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Record Not Found' });
            }
          });

      },
      reject: () => {
      }

    });
  }

  isFirmActiveChange(fieldValue:any,rowData:any){
    let mpid= this.UserService.getActiveMPID();
    let message='';
    if(fieldValue == 1){
      message  ='Do You Want to DeActivate  ' + rowData["Exception_CD"] + ' Exception for '+ mpid +'?';
    }
    else{
       message  ='Do You Want to make ' + rowData["Exception_CD"] + ' Exception Active for '+ mpid +'?';
    }
    this.confirmationService.confirm({
        message: message,
        key: 'submitInformationDialoge',
        acceptLabel: 'Yes',
        acceptIcon:'pi pi-check',
        rejectLabel: 'No',
        rejectIcon:'pi pi-times',
        acceptButtonStyleClass:"information-dialog-button",
        rejectButtonStyleClass:"information-dialog-button information-reject-button",

        accept: () => {
        this.UserService.logUserActivity((fieldValue == 1 ? "Deactivate" +" "+ rowData["Exception_CD"]  +" "+  "exception for " +" "+ mpid : "Activate" +" "+ rowData["Exception_CD"] +" "+ "exception for" +" "+ mpid), null, {
        'Text1': (fieldValue ? "Deactivate" +" "+ rowData["Exception_CD"] +" "+  "exception for " +" "+ mpid : "Activate" +" "+ rowData["Exception_CD"] +" "+ "exception for" +" "+ mpid),
        'Text2': 'Comparative review setup MPID details: ' + JSON.stringify(rowData)
        });
          this.isLoadingResults =true; 
          let data
          if(fieldValue == 1){
          data = {
          "level": "firm",
          "Active":"N",
          "mpid":mpid,
          "Exception_CD": rowData["Exception_CD"],
          "Created_By":this.UserService.getUserFirstName(),
          "LastUpdated_By": this.UserService.getUserFirstName(),
        };
      }
      else{
         data = {
          "level": "firm",
          "mpid":mpid,
          "Exception_CD": rowData["Exception_CD"],
        };
      }
        this.sharedHttpClientService.post(this.urlsService.setAPIURl(APIURL.UpdateCompReviewsetupDetails), data)
          .pipe(map((response: Response) => {
            return response;
          }))
          .subscribe({
            next: (dataset: any) => {
              this.getData();
              this.messageService.add({ severity: 'success', summary: 'Updated', detail: 'Record Updated' });
            },
            error: (err: HttpErrorResponse) => {
              this.isLoadingResults = false;
              this.messageService.add({ severity: 'error', summary: 'Error', detail: 'Record Not Found' });
            }
          });

        },
        reject: () => {
      }
     
      });
  }
  ngOnDestroy() {
    if(this.subscription)
    this.subscription.unsubscribe();
  }
}

